export const metaData = {
	login: {
		title: 'SMART PROPERTY UAE | Login',
		description: '',
		keywords: '',
	},
	signUp: {
		title: 'SMART PROPERTY UAE | Registration',
		description: '',
		keywords: '',
	},
	requests: {
		title: 'SMART PROPERTY UAE | Client requests',
		description: '',
		keywords: '',
	},
	consultations: {
		title: 'SMART PROPERTY UAE | Consultations',
		description: '',
		keywords: '',
	},
	saved: {
		title: 'SMART PROPERTY UAE | Saved',
		description: '',
		keywords: '',
	},
	logs: {
		title: 'SMART PROPERTY UAE | Logs',
		description: '',
		keywords: '',
	},
	organizations: {
		title: 'SMART PROPERTY UAE | Organizations',
		description: '',
		keywords: '',
	},
	complexes: {
		title: 'SMART PROPERTY UAE | Living complexes',
		description: '',
		keywords: '',
	},
	lots: {
		title: 'SMART PROPERTY UAE | Lots',
		description: '',
		keywords: '',
	},
	users: {
		title: 'SMART PROPERTY UAE | Users',
		description: '',
		keywords: '',
	},
};
